import React from 'react'

import { competitorLogo } from '../assets'
import { trackEvent } from 'services/analytics'
import {
  Action, Card, Description, Grid, Logo, LogoFallback, Maintainer, Status, Title,
} from './styled'

export default function AssistantGrid({ assistants, ownerLabel, t }) {
  return (
    <Grid>
      {assistants.map(assistant => (
        <Card key={assistant.key}>
          {competitorLogo(assistant.key) ? <Logo src={competitorLogo(assistant.key)} alt={assistant.displayName} /> : <LogoFallback>{assistant.displayName}</LogoFallback>}
          <Title>{assistant.displayName} {t('competitive_intelligence_assistant_specialist')}</Title>
          <Maintainer>{t('competitive_intelligence_assistant_maintained_by')} {ownerLabel}</Maintainer>
          <Description>{assistant.tagline || assistant.knowledgeScope || t('competitive_intelligence_assistant_description')}</Description>
          {assistant.available && assistant.externalUrl ? (
            <Action href={assistant.externalUrl} onClick={() => trackEvent('COMPETITIVE_AI_ASSISTANT_OPENED', {
              competitive_section: 'assistants', assistant_id: assistant.key,
            })} target="_blank" rel="noopener noreferrer">
              {t('competitive_intelligence_assistant_open')} ↗
            </Action>
          ) : <Status>{t('competitive_intelligence_assistant_coming_soon')}</Status>}
        </Card>
      ))}
    </Grid>
  )
}
